import React, { useEffect, useState } from "react";
import "./SideBar.css";
import { NavLink } from "react-router-dom";
import SmcLogo from "../../../Images/smclogo.png";
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';


const SideBar = () => {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        const checkScreenSize = () => {
            setIsVisible(window.innerWidth > 768);
        };

        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);

        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);
    return (
        <div className={isVisible ? "col-md-2 sidebar" : "MobileViewSidebar"}>
            <div className="Logo">
                <a href="/customers">
                    <img src={SmcLogo} alt="" className="img-fluid" />
                    </a>
                </div>
            {["md"].map((expand) => (
                <Navbar key={expand} expand={expand} >
                    <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="start"
                    >
                        <div className="navlist">
                            <Offcanvas.Header closeButton>
                                {!isVisible &&
                                    <div className="Logo">
                                        <a href="/customers">
                                            <img src={SmcLogo} alt="" className="img-fluid" />
                                        </a>
                                    </div>
                                }
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <NavLink to="https://www.smcinsurance.com/" className="navitem">
                                    <i class="fas fa-home"></i>
                                    <span>Booking Policy</span>
                                </NavLink>
                                <NavLink to="/dashboard" className="navitem">
                                    <svg
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 14 14"
                                        className="paint"
                                    >
                                        <path
                                            id="Icon_material-dashboard"
                                            data-name="Icon material-dashboard"
                                            className="cls-1"
                                            d="m0,7.78h6.22V0H0v7.78Zm0,6.22h6.22v-4.67H0v4.67Zm7.78,0h6.22v-7.78h-6.22v7.78ZM7.78,0v4.67h6.22V0h-6.22Z"
                                        />
                                    </svg>
                                    <span>Dashboard</span>
                                </NavLink>
                                <NavLink to="/recently-viewed-plans" className="navitem">
                                    <i class="fas fa-eye"></i>
                                    <span>Recently Viewed Plans</span>
                                </NavLink>
                                <NavLink to="/family-hierarchy-view" className="navitem">
                                    <i class="fas fa-sitemap"></i>
                                    <span>Family Hierarchy View</span>
                                </NavLink>
                                {/*<NavLink to="/endorsements" className="navitem">*/}
                                {/*    <i class="fas fa-check-double"></i>*/}
                                {/*    <span className="nav-item">Endorsements</span>*/}
                                {/*</NavLink>*/}
                                {/*<NavLink to="/policy-sync" className="navitem">*/}
                                {/*    <i class="fas fa-sync-alt"></i>*/}
                                {/*    <span className="nav-item">Policy Syncing</span>*/}
                                {/*</NavLink>*/}
                                <NavLink to="/cliam-intimation" className="navitem">
                                    <i class="fas fa-file-invoice"></i>
                                    <span className="nav-item">Claim Intimation</span>
                                </NavLink>
                                <NavLink to="https://www.google.com/search?q=smc+insurance&source=hp&ei=IPs8ZPuKJtLM2roPtv2RiAQ&iflsig=AOEireoAAAAAZD0JMNrG6IcyYfL3cU6EGOsRiFq_7htJ&gs_ssp=eJzj4tZP1zcsKTBINrQ0NmC0UjWoMLY0SE41sbRINYUAK4OKRNO0RCMzgySztCQTc0NTIy_e4txkhcy84tKixLzkVABXnRL1&oq=smc+&gs_lcp=Cgdnd3Mtd2l6EAEYBDIQCC4QxwEQsQMQ0QMQigUQQzIHCAAQigUQQzIQCC4QrwEQxwEQsQMQigUQQzIICAAQgAQQsQMyCwguEIAEEMcBEK8BMg0IABCKBRCxAxCDARBDMgsILhCABBDHARCvATIFCAAQgAQyDQgAEIoFELEDEIMBEEMyCwguEIAEEMcBEK8BOg0IABCKBRDqAhC0AhBDOhcIABCKBRDqAhC0AhCKAxC3AxDUAxDlAjoLCAAQgAQQsQMQgwE6EQguEIMBEMcBELEDENEDEIAEOgsILhCKBRCxAxCDAToLCC4QgAQQsQMQgwE6CggAEIoFELEDEEM6EAguEIoFELEDEIMBENQCEEM6CQgAEIoFEAoQQzoQCC4QigUQsQMQxwEQrwEQQ1CNBVizE2DEMmgBcAB4AIABlAOIAf4GkgEJMC4yLjEuMC4xmAEAoAEBsAEK&sclient=gws-wiz#lrd=0x390ce498e5555555:0xa5fa260b6fb47152,1,,,," target="_blank" className="navitem">
                                    <i class="fas fa-thumbs-up"></i>
                                    <span className="nav-item">Rate Us</span>
                                </NavLink>
                                <NavLink to="https://www.smcinsurance.com/epartner" className="navitem">
                                    <i class="fas fa-handshake"></i>
                                    <span className="nav-item">Become a Sales Partner</span>
                                </NavLink>
                                <NavLink to="https://www.smcinsurance.com/articles" className="navitem">
                                    <i class="fas fa-list-alt"></i>
                                    <span className="nav-item">Insurance Articles</span>
                                </NavLink>

                            </Offcanvas.Body>
                        </div>
                    </Navbar.Offcanvas>
                </Navbar>
            ))}
        </div>
    );
};

export default SideBar;
